import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { ListPageColumnComponent } from 'design-system';

@Component({
  selector: 'rev-customer-price-list-cell',
  imports: [CommonModule, MatChipsModule],
  templateUrl: './receipts-customer-price-list-cell.html',
  styleUrl: './receipts-customer-price-list-cell.scss',
})
export class receiptsCustomerPriceListCell extends ListPageColumnComponent implements OnInit {
  @Input() priceList = '';

  ngOnInit(): void {
    if (this.itemData && this.infoColumn) {
      this.priceList = this.itemData[this.infoColumn.columnNameDef];
    }
  }

  get cssClass(): string {
    switch (this.priceList) {
      case 'Oil':
        return 'oil';
      case 'NonOil':
        return 'non-oil';
      case 'agenti':
        return 'listino-agenti';
      default:
        return 'listino-unknown';
    }
  }

  get label(): string {
    switch (this.priceList) {
      case 'Oil':
        return 'Oil';
      case 'NonOil':
        return 'Non Oil';
      case 'agenti':
        return 'Agente';
      default:
        return 'Libero';
    }
  }
}
